<!-- eslint-disable vue/no-mutating-props -->
<template>
  <el-card class="config-card mb-5">
    <div slot="header" class="flex">Eliza</div>
    <el-form
      :disabled="!contractedServices.eliza"
      class="config-card__body"
      label-position="top"
      size="mini"
    >
      <slot />
      <el-form-item label="Estado de Eliza">
        <el-radio-group v-model="parsedStatus" size="mini">
          <el-radio-button label="Disabled">Desactivada</el-radio-button>
          <el-radio-button label="Enabled">Activada para todas las llamadas</el-radio-button>
          <el-radio-button label="WithConditions">Activada con condiciones</el-radio-button>
        </el-radio-group>
      </el-form-item>

      <div v-if="!config.triggers.always && parsedStatus !== 'Disabled'">
        <div class="flex">
          <el-form-item label="Activar si hay al menos llamadas en cola">
            <el-input-number v-model="config.triggers.callsInQueue" @change="save" />
          </el-form-item>

          <el-form-item label="Activar cuando no haya agentes disponibles">
            <el-switch v-model="config.triggers.agentsBusy" active-color="#13ce66" @change="save" />
          </el-form-item>

          <el-form-item
            :class="formItemErrorClass($v.config.triggers.olderCallWaiting)"
            label="Activar si el tiempo de espera de la llamada más antigua es superior a"
          >
            <div class="mb-1" style="width: 150px">
              <el-input
                v-model="config.triggers.olderCallWaiting"
                :controls="false"
                max="300"
                min="10"
                @change="save"
              >
                <div slot="append">segundos</div>
              </el-input>
            </div>
            <error-message :data="$v.config.triggers.olderCallWaiting" validation="min">
              Debe ser igual o mayor que 10 segundos
            </error-message>
            <error-message :data="$v.config.triggers.olderCallWaiting" validation="max">
              Debe ser menor o igual que 600 segundos
            </error-message>
          </el-form-item>
        </div>
      </div>

      <div v-if="contractedServices.eliza" class="mt-4">
        <el-divider content-position="left">Configuración clientes</el-divider>

        <div class="flex">
          <div>
            <el-form-item label="Estado para nuevos clientes">
              <el-switch
                v-model="customers.defaultEnableEliza"
                active-color="#13ce66"
                @change="saveCustomersConfig"
              />
            </el-form-item>
          </div>
          <div>
            <el-form-item label="Acciones sobre clientes">
              <el-button-group>
                <el-popconfirm
                  :title="`¿Quiéres activar eliza para todos los clientes?`"
                  cancelButtonText="No"
                  confirmButtonText="Sí"
                  iconColor="red"
                  placement="left"
                  @confirm="handleEnableToAllCustomers"
                >
                  <el-button slot="reference" size="mini">Activar para todos lo clientes</el-button>
                </el-popconfirm>
                <el-popconfirm
                  class="ml-2"
                  :title="`¿Quiéres desactivar eliza para todos los clientes?`"
                  cancelButtonText="No"
                  confirmButtonText="Sí"
                  iconColor="red"
                  placement="left"
                  @confirm="handleDisableToAllCustomers"
                >
                  <el-button slot="reference" size="mini"
                    >Desactivar para todos los clientes</el-button
                  >
                </el-popconfirm>
              </el-button-group>
            </el-form-item>
          </div>
        </div>
      </div>
    </el-form>
  </el-card>
</template>

<script>
import { setElizaStatus } from "@/api/operations/customers.ts";
import { maxValue, minValue } from "vuelidate/lib/validators";
import ErrorMessage from "@/components/common/forms/ErrorMessage";
import errors from "@/mixins/errors";

export default {
  name: "ElizaConfiguration",

  components: {
    ErrorMessage,
  },
  mixins: [errors],
  props: {
    contractedServices: Object,
    workgroupId: Number,
    customers: {
      type: Object,
      default: () => ({}),
    },
    config: {
      type: Object,
      default: () => ({
        on: false,
        triggers: {
          always: false,
          callsInQueue: null,
          agentsBusy: false,
          olderCallWaiting: null,
        },
      }),
    },
  },
  validations: {
    config: {
      triggers: {
        olderCallWaiting: {
          min: minValue(10),
          max: maxValue(600),
        },
      },
    },
  },
  computed: {
    parsedStatus: {
      get() {
        if (!this.config.on) {
          return "Disabled";
        }
        if (this.config.triggers.always) {
          return "Enabled";
        }
        return "WithConditions";
      },
      set(value) {
        switch (value) {
          case "Disabled":
            this.config.on = false;
            break;
          case "Enabled":
            this.config.on = true;

            this.config.triggers.always = true;
            break;
          case "WithConditions":
            this.config.on = true;

            this.config.triggers.always = false;
            break;
        }
        this.save();
      },
    },
  },
  methods: {
    save() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$emit("updateElizaConfiguration", JSON.parse(JSON.stringify(this.config)));
      }
    },
    saveCustomersConfig() {
      this.$emit("updateElizaCustomersConfiguration", JSON.parse(JSON.stringify(this.customers)));
    },
    async handleEnableToAllCustomers() {
      try {
        await setElizaStatus(this.workgroupId, true);
        this.$message.success("Eliza activado para todos los clientes");
      } catch (e) {
        this.$message.error("No se ha podido activar Eliza para todos los clientes");
      }
    },
    async handleDisableToAllCustomers() {
      try {
        await setElizaStatus(this.workgroupId, false);
        this.$message.success("Eliza desactivado para todos los clientes");
      } catch (e) {
        this.$message.error("No se ha podido desactiver Eliza para todos los clientes");
      }
    },
  },
};
</script>

<style>
.flex {
  display: flex;
  align-items: flex-start;
  gap: 30px;
}

.el-divider__text {
  font-size: 13px !important;
}
</style>
